import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import MockPayPal from "@/pages/MockPayPal";
import PayPalReturn from "@/pages/PayPalReturn";
import Bundle from "@/pages/Bundle";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Contact from "@/pages/Contact";
import { AuthProvider, CartProvider } from "@/lib/store";
import { initPixels, track } from "@/lib/pixels";

function AppRouter() {
  const loc = useLocation();
  // Load ad pixels once
  React.useEffect(() => { initPixels(); }, []);
  // Fire PageView on every route change (also captures initial load once pixels are ready)
  React.useEffect(() => {
    let mounted = true;
    initPixels().then(() => { if (mounted) track("PageView"); });
    return () => { mounted = false; };
  }, [loc.pathname]);
  // Emergent OAuth callback via URL fragment
  if (loc.hash?.includes("session_id=") && loc.pathname !== "/auth/callback") {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/bundle/:slug" element={<Bundle />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/mock-paypal" element={<MockPayPal />} />
        <Route path="/order/paypal-return" element={<PayPalReturn />} />
        <Route path="/order/success" element={<OrderSuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/account" element={<Account />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
